import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=2578bb23&scoped=true&"
import script from "./CreatePost.vue?vue&type=script&lang=ts&"
export * from "./CreatePost.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=2578bb23&lang=scss&scoped=true&"
import style1 from "./CreatePost.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578bb23",
  null
  
)

export default component.exports